import React from 'react';
import { Grid, Box, Typography, Stack } from '@mui/material';
import { images } from '../assets/images';
import { rotations } from '../data';
import { Section, Heading, Img } from './common';

const Internship = () => (
  <Section id="internship" bg="primary.dark">
    <Grid container spacing={{ xs: 5, md: 9 }} alignItems="center">
      <Grid item xs={12} md={6}>
        <Box sx={{ aspectRatio: '5 / 4', borderRadius: '12px', overflow: 'hidden' }}>
          <Img src={images.internship} alt="Students explaining care to patients in a hospital ward" />
        </Box>
      </Grid>
      <Grid item xs={12} md={6}>
        <Heading light title="Six months of rotatory internship" text="The internship moves you from learning under supervision to practising with growing independence. You assess patients, plan and deliver treatment, keep clinical records and work alongside doctors and nurses." sx={{ mb: 4 }} />
        <Stack>
          {rotations.map((r) => (
            <Box key={r} sx={{ py: 1.75, borderTop: '1px solid rgba(255,255,255,0.18)', '&:last-of-type': { borderBottom: '1px solid rgba(255,255,255,0.18)' } }}>
              <Typography sx={{ color: '#fff', fontWeight: 600 }}>{r}</Typography>
            </Box>
          ))}
        </Stack>
      </Grid>
    </Grid>
  </Section>
);

export default Internship;
